import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  PricingSchemeContainerModel,
  PricingSchemeService
} from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-util-pricing-scheme-hdr',
  templateUrl: './pricing-scheme-hdr.component.html',
  styleUrls: ['./pricing-scheme-hdr.component.css']
})
export class UtilPricingSchemeHdrComponent implements OnInit, OnDestroy {
  @Input() pricingScheme = new FormControl();
  @Output() pricingSchemeSelected = new EventEmitter<PricingSchemeContainerModel>();

  selectedEntity: PricingSchemeContainerModel;
  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<PricingSchemeContainerModel[]> = new ReplaySubject<PricingSchemeContainerModel[]>(1);
  entityList: PricingSchemeContainerModel[];

  constructor( private pricingSchemeService: PricingSchemeService, ) {}

  ngOnInit() {
    this.subs.sink = this.pricingSchemeService.get(this.apiVisa).subscribe(
      {next: resolve => {
        this.entityList = resolve.data;
        this.filteredOptions$.next(this.entityList);
      }});

    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterCurrency(resolve)});
  }

  filterCurrency(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.entityList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.entityList.filter(c => c.bl_fi_mst_pricing_scheme_hdr.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  onSelect(entityGuid: string) {
    console.log('pricing', entityGuid);
    if (entityGuid) {
      this.pricingScheme.patchValue(entityGuid);
      this.selectedEntity = this.entityList.find(agent => agent.bl_fi_mst_pricing_scheme_hdr.guid === entityGuid);
      this.pricingSchemeSelected.emit(this.selectedEntity);

    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

